<ul *ngIf="profileMenuItems.length > 0" class="mui-main-navigation__head">
  <li
    *ngFor="let item of profileMenuItems"
    class="mui-main-navigation__entry"
    [class.has--submenu]="item.children && item.children.length > 0"
    [class.is--active]="isActiveLink(item)"
    [class.is--open]="isActiveLink(item)">
    <a [mmuMainMenuLink]="item.link"
      [isExternalLink]="item.isExternalLink"
      [userType]="userType"
      [avatar]="item.label"
      [title]="item.label"
    >
      <ng-container
        [ngTemplateOutlet]="menuItemLabelTemplate ? menuItemLabelTemplate : defaultLabelTemplate"
        [ngTemplateOutletContext]="{ $implicit: item.label }"></ng-container>
      <div class="mui-copytext--sm mui-no-margin mui-copytext--tertiary" *ngIf="userType === 'service'">
        {{ serviceLabel }}
      </div>
    </a>
    <ng-container *ngIf="item.children && item.children.length > 0">
      <i mui-icon name="chevron-right" font="fa" class="mui-main-navigation__opener" (click)="toggleMenu($event)"></i>
      <ul class="mui-main-navigation__submenu">
        <li *ngFor="let subItem of item.children" class="mui-main-navigation__entry" [class.is--active]="isActiveLink(subItem)">
          <a [mmuMainMenuLink]="subItem.link" [isExternalLink]="subItem.isExternalLink" [class.is--active]="isActiveLink(subItem)">
            <ng-container
              [ngTemplateOutlet]="menuItemLabelTemplate ? menuItemLabelTemplate : defaultLabelTemplate"
              [ngTemplateOutletContext]="{ $implicit: subItem.label }"></ng-container>
          </a>
        </li>
      </ul>
    </ng-container>
  </li>
</ul>
<ng-container
  [ngTemplateOutlet]="!collapsed || !isScrollable ? menuSeparator : scrollingArrowButton"
  [ngTemplateOutletContext]="{ $implicit: 'up' }"></ng-container>
<ul *ngIf="menuItems.length > 0" #navBar class="mui-main-navigation__nav">
  <li
    *ngFor="let item of menuItems"
    (mouseenter)="onMouseOver(item, $event)"
    (mouseleave)="onMouseLeave(item, $event)"
    class="mui-main-navigation__entry"
    [class.has--submenu]="item.children && item.children.length > 0"
    [class.is--active]="isActiveLink(item)"
    [class.is--open]="isActiveLink(item)">
    <!-- this item will be tracked if item.tracked is true - TODO: for now not tested -->
    <a
      [mmuMainMenuLink]="item.link"
      [mmuTrackMainMenuItem]="item"
      [isExternalLink]="item.isExternalLink"
      [icon]="item.icon"
      [iconFont]="item.iconFont ? item.iconFont : 'fa'">
      <ng-container
        [ngTemplateOutlet]="menuItemLabelTemplate ? menuItemLabelTemplate : defaultLabelTemplate"
        [ngTemplateOutletContext]="{ $implicit: item.label }"></ng-container>
    </a>
    <ng-container *ngIf="item.children && item.children.length > 0">
      <i mui-icon name="chevron-right" font="fa" class="mui-main-navigation__opener" (click)="toggleMenu($event)"></i>
      <ul class="mui-main-navigation__submenu">
        <li *ngFor="let subItem of item.children" class="mui-main-navigation__entry" [class.is--active]="isActiveLink(subItem)">
          <a [mmuMainMenuLink]="subItem.link" [isExternalLink]="subItem.isExternalLink" [class.is--active]="isActiveLink(subItem)">
            <ng-container
              [ngTemplateOutlet]="menuItemLabelTemplate ? menuItemLabelTemplate : defaultLabelTemplate"
              [ngTemplateOutletContext]="{ $implicit: subItem.label }"></ng-container>
          </a>
        </li>
      </ul>
    </ng-container>
  </li>
</ul>

<ng-container
  *ngIf="collapsed"
  [ngTemplateOutlet]="isScrollable ? scrollingArrowButton : menuSeparator"
  [ngTemplateOutletContext]="{ $implicit: 'down' }"></ng-container>
<div class="mui-main-navigation__footer">
  <ng-content></ng-content>
  <a
    mmuMainMenuLink
    *ngIf="collapsible"
    (click)="toggleCollapseState()"
    [icon]="collapsed ? 'chevron-double-right' : 'chevron-double-left'"
    id="collapse-menu-button"
    class="mui-main-navigation__menu-btn d-none d-lg-flex">
    {{ collapseLabel }}
  </a>
</div>

<ng-template #defaultLabelTemplate let-label>{{ label }}</ng-template>

<ng-template #menuSeparator>
  <div class="mui-main-navigation__menu-separator"></div>
</ng-template>
<ng-template #scrollingArrowButton let-direction>
  <div
    class="mui-main-navigation__scrolling-button"
    (mousedown)="startScroll(direction)"
    (mouseup)="stopScroll()"
    (mouseleave)="stopScroll()">
    <i mui-icon [name]="'chevron-' + direction" font="fa"> </i>
  </div>
</ng-template>
